import { RoutingHistoryService } from './../services/routingHistory.service';
import { Component } from "@angular/core";
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

@Component({
    styles: [`
        h4 {
            text-align: center;
        }

        .mat-card {
            height: 90%;
            width: 90%
        }

        mat-card-content.mat-card-content {
            height: 50%;
        }

        mat-grid-list.mat-grid-list {
            height: 100% !important;
            padding-bottom: 0px !important;
        }
    `],
    template: `
        <div fxLayout="column">
            <div>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <h2>Keyword and Phrase Topic Starters</h2>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <div fxLayout="column" fxLayoutAlign="center center" fxFlex.gt-sm="550px;" fxFlex.sm="450px;" fxFlex.xs="350px;">
                        <p style="margin-bottom: 0px; margin-top: 0px;">Creating topics is simple.</p>
                        <p style="margin-top: 3px;">
                            You start with keywords and phrases about your desired topic. 
                            We created examples for a variety of topics using different approaches to the keywords or phrases. 
                            Just select one to start and change it as needed.
                        </p>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" style="overflow-y: auto; height: calc(100vh - 230px)">
                    <mat-grid-list [cols]="cols" rowHeight="400px" fxFlexOffset="5" fxFlex="90">
                        <mat-grid-tile *ngFor="let seed of seeds" fxLayoutAlign="center center">
                            <mat-card style="width: 100%; margin: 20px;">
                                <mat-card-title>
                                    <span fxFlex></span>
                                    <h4>{{seed.title}}</h4>
                                    <span fxFlex></span>
                                </mat-card-title>
                                <mat-card-content>
                                    <p>{{seed.description}}</p>
                                </mat-card-content>
                                <mat-card-actions>
                                    <span fxFlex></span>
                                    <a mat-raised-button color="primary" [routerLink]="['/topics', 'builder']" [queryParams]="seed.queryParams">
                                        Use Seed
                                    </a>
                                    <span fxFlex></span>
                                </mat-card-actions>
                            </mat-card>
                        </mat-grid-tile>
                    </mat-grid-list>
                </div>
            </div>
        </div>
    `
})
export class StartersCreateTopicComponent {
    seeds = [
        { 
            title: 'AI and Ethics', 
            description: 'Articles about artificial intelligence in context of ethic considerations. This seed uses simple keywords [AI, ethical] and the match type [Include All Keywords].',
            queryParams: {name: 'AI and Ethics', term: 'AI, ethical', matchType: 'IncludeAllKeywords'} },
        {   
            title: 'Blockchain For Business', 
            description: 'Articles about blockchain technologies for business applications. This seed uses a large set of keywords and phrases  [blockchain for business, blockchain services, blockchain deployment, blockchain in insurance, blockchain in healthcare, blockchain in supply chain] and the match type [Include Any Keywords].',
            queryParams: {name: 'Blockchain For Business', term: 'blockchain for business, blockchain services, blockchain deployment, blockchain in insurance, blockchain in healthcare, blockchain in supply chain', matchType: 'IncludeAnyKeywords'} },
        { 
            title: 'Blockchain Applications', 
            description: 'Blockchain for business applications including blockchain in legal, supply chain, insurance and health care applications. This seed is is an example of using a Boolean query: "blockchain" AND (legal, OR "supply chain" OR "health care" OR insurance). The match type in this case is ignored because of the Boolean query.',
            queryParams: {name: 'Blockchain Applications', term: '"blockchain" AND (legal, OR "supply chain" OR "health care" OR insurance)', matchType: 'IncludeAllKeywords'} },
        { 
            title: 'Business Intelligence', 
            description: 'Articles about business intelligence tools and deployments.  This seed combines multiple keywords and broad match any approach.  Keywords [business intelligence, business intelligence tools, business intelligence strategy, business intelligence deployment] and match type [Any Keywords].',
            queryParams: {name: 'Business Intelligence', term: 'business intelligence, business intelligence tools, business intelligence strategy, business intelligence deployment', matchType: 'IncludeAnyKeywords'} },
        { 
            title: 'Electric cars', 
            description: 'Articles about electric mobility and electric cars technology.  This seed uses a simple set of keywords [electric cars, electric trucks, electric bus] with a match type [Include Any Keywords].',
            queryParams: {name: 'Electric cars', term: 'electric cars, electric trucks, electric bus', matchType: 'IncludeAnyKeywords'} },
        { 
            title: 'Ethical Fashion', 
            description: 'News, opinion and perspectives related to Ethical and Sustainable Fashion.  This seed uses a simple set of keywords [ethics sustainable fashion] and the match type [Include All Keywords].',
            queryParams: {name: 'Ethical Fashion', term: 'ethics sustainable fashion', matchType: 'IncludeAllKeywords'} },
        { 
            title: 'Machine Learning', 
            description: 'Articles about the latest news and development in machine learning and deep learning.  This seed uses two common phrases [machine learning, deep learning] with the match type [Include Any Keywords] to assure that either phrase is present.',
            queryParams: {name: 'Machine Learning', term: 'machine learning, deep learning', matchType: 'IncludeAnyKeywords'} },
        { 
            title: 'Payment  Gateways', 
            description: 'Articles about payment processing gateways and technologies. This seed uses specific terms of the trade and is an example of using Boolean query: ["payment processors" OR "payment gateways" OR "payment system"]. The match type in this case is ignored because of the Boolean query.',
            queryParams: {name: 'Payment Processor Gateways', term: '"payment processors" OR "payment gateways" OR "payment system"', matchType: 'IncludeAllKeywords'} },
        { 
            title: 'Privacy Regulation', 
            description: 'Articles about the European GDPR privacy regulation, other privacy regulation and IT risk analysis regarding privacy compliance.  This seed uses multiple keywords [gdpr, privacy regulation, privacy rules, privacy risk, privacy regulation compliance] with the match type [Include Any Keywords].',
            queryParams: {name: 'Privacy Regulation', term: 'gdpr, privacy regulation, privacy rules, privacy risk, privacy regulation compliance', matchType: 'IncludeAnyKeywords'} },
        { 
            title: 'Public Speaking', 
            description: 'Articles about public speaking and presentations.  This seed uses a simple keyword phrase [public speaking] and the match type [Match Exact Phrase].',    
            queryParams: {name: 'Public Speaking', term: 'public speaking', matchType: 'MatchExactPhrase'} },
        { 
            title: 'Software As A Service', 
            description: 'Articles about Saas marketing, sales and pricing.  This seed uses multiple keyword phrases [saas marketing, saas pricing, saas sales] with the match type [Include Any Keywords].',
            queryParams: {name: 'Software As A Service', term: 'Saas marketing, Saas pricing, Saas sales', matchType: 'IncludeAnyKeywords'} },
        { 
            title: 'Human leukocyte antigen', 
            description: 'News and published articles regarding Human leukocyte antigen.  This seed seeks content related to a specific scientific term and it uses the keyword phrase [Human leukocyte antigen] together with the match type [Match Exact Phrase].',
            queryParams: {name: 'Human leukocyte antigen', term: 'Human leukocyte antigen', matchType: 'MatchExactPhrase'} },
    ];
    cols = 3;

    constructor(private router: Router, media: MediaObserver, private routingHistoryService: RoutingHistoryService) {
        media.media$.subscribe((change: MediaChange) => this.cols = change.mqAlias === 'xs' ? 1 : (this.cols = change.mqAlias === 'sm' ? 2 : 3));
    }
}